<template>
  <smooth-scrollbar>
    <div class="vector-group" style="margin:0 1.4rem; height: 56vh;">
      <vector-group v-for="(_vectors,index) in vectors_group" :key="index" :group="_vectors"></vector-group>
    </div>
  </smooth-scrollbar>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import vectorGroup from "./vector-group.component";
import _ from "lodash";
export default {
  components: {
    vectorGroup
  },
  computed: {
    ...mapState(["vectors"]),
    vectors_group() {
      return _.groupBy(this.vectors, "group");
    }
  }
};
</script>


